import React, { Suspense, useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useCookies, withCookies } from "react-cookie";

// Admin
import BankList from "../containers/Bank/index";
import ModifyBank from "../containers/Bank/modify-bank";

// Owner
import Login from "../containers/Login/login.component";
import StudioLogin from "../containers/StudioLogin/studio-login.component";
import Register from "../containers/RegisterStudio/register.component";
import RegisterStudent from "../containers/RegisterStudent/index";
import WelcomeOwner from "../containers/Owner/welcome.component";
import AddClassOwner from "../containers/Owner/add-class-component";
import VerifyOtp from "../containers/Login/verify-otp.component";
import ChooseStudio from "../containers/Login/choose-studio.component";
import Dashboard from "../containers/Studio/Owner/Dashboard/dashboard.component";
import TeacherDashBoard from "../containers/Studio/Owner/Dashboard/dashboard.component.teacher";
import { Students } from "../containers/Studio/Owner/Students/students.component";
import { AddStudent } from "../containers/Studio/Owner/Students/add-student.component";
import { Classes } from "../containers/Studio/Owner/Classes/classes.component";
import { AddClass } from "../containers/Studio/Owner/Classes/addClass/add-class.component";
import GeneralTerms from "../containers/RegisterStudent/general-terms";
import { EditClass } from "../containers/Studio/Owner/Classes/EditClass/index";
import DetailClass from "../containers/Studio/Owner/Classes/detail";
import { Teachers } from "../containers/Studio/Owner/Teachers";
import AddTeachers from "../containers/Studio/Owner/Teachers/modify";
import TeacherDetail from "../containers/Studio/Owner/Teachers/detail";
import DetailStudent from "../containers/Studio/Owner/Students/detail";
import { AddNotes } from "../containers/Studio/Owner/Students/add-notes";
import Settings from "../containers/Studio/Owner/Settings";
import { TermsAndConditions } from "../containers/Studio/Owner/Settings/terms-and-conditions";
import { Cancellation } from "../containers/Studio/Owner/Settings/cancellation";
import SettingPayment from "../containers/Studio/Owner/Settings/payment";
import { MidtransConfiguration } from "../containers/Studio/Owner/Settings/MidtransConfiguration";
import EditProfile from "../containers/Studio/Owner/Profile/edit-profile";
import SettingPlans from "../containers/Studio/Owner/Settings/Plans/plans";
import DetailPlan from "../containers/Studio/Owner/Settings/Plans/detail-plan";
import ModifyPLan from "../containers/Studio/Owner/Settings/Plans/modify-plans";
import VerifyEmailOwner from "../containers/Studio/Owner/Profile/verify-email";
import ChangeEmailOwner from "../containers/Studio/Owner/Profile/change-email";

// Students
import PlanList from "../containers/Studio/Students/students-plan/index";
import ClassList from "../containers/Studio/Students/students-class/index";
import StudentDashboard from "../containers/Studio/Students/dashboard/index";
import CancelClass from "../containers/Studio/Students/dashboard/cancel-class";
import CancelClassComplete from "../containers/Studio/Students/dashboard/cancel-class-complete";
import StudentProfile from "../containers/Studio/Students/students-profile/edit-profile";
import VerifyEmail from "../containers/Studio/Students/students-profile/verify-email";
import ChangeEmail from "../containers/Studio/Students/students-profile/change-email";
import PaymentClass from "../containers/Studio/Students/students-class/payment";
import ChoosePayment from "../containers/Studio/Students/students-payment/choose-payment";
import BankTransfer from "../containers/Studio/Students/students-payment/bank-transfer";
import WaitingPayment from "../containers/Studio/Students/students-payment/waiting-payment";
import PaymentVerification from "../containers/Studio/Students/students-payment/payment-verification";
import PaymentProcessed from "../containers/Studio/Students/students-payment/transfer-success";
import DetailTransaction from "../containers/Studio/Students/students-plan/detail-transaction";
import BuyPlans from "../containers/Studio/Students/students-plan/offering-plans";
import MidtransCallbackSucces from "../containers/Studio/Students/students-payment/midtrans-success";
import ConfirmClass from "../containers/Studio/Students/students-class/confirm-class";
import DashboardClassDetail from "../containers/Studio/Owner/Dashboard/class-detail";
import PublicClassList from "../containers/Studio/Students/students-class/public-class-list";
import ListStatistic from "../containers/Studio/Owner/Dashboard/list-statistic";

const admin_routes = [
  {
    path: "/banks",
    component: BankList,
    exact: true,
  },
  {
    path: "/bank/add",
    component: ModifyBank,
    exact: true,
  },
  {
    path: "/bank/edit/:id",
    component: ModifyBank,
    exact: true,
  },
];

const routes = [
  {
    path: "/choose-studio",
    component: ChooseStudio,
    exact: true,
  },
];

const studio_routes = [
  {
    path: "/dashboard",
    component: Dashboard,
    exact: true,
  },
  {
    path: "/list-statistic",
    component: ListStatistic,
    exact: true,
  },
  {
    path: "/onboarding",
    component: WelcomeOwner,
    exact: true,
  },
  {
    path: "/basic-settings",
    component: AddClassOwner,
    exact: true,
  },
  {
    path: "/students",
    component: Students,
    exact: true,
  },
  {
    path: "/add-student",
    component: AddStudent,
    exact: true,
  },
  {
    path: "/student/:id/detail",
    component: DetailStudent,
    exact: true,
  },
  {
    path: "/student/:id/edit",
    component: AddStudent,
    exact: true,
  },
  {
    path: "/add/notes",
    component: AddNotes,
    exact: true,
  },
  {
    path: "/edit/notes",
    component: AddNotes,
    exact: true,
  },
  {
    path: "/settings",
    component: Settings,
    exact: true,
  },
  {
    path: "/setting-terms-and-conditions",
    component: TermsAndConditions,
    exact: true,
  },
  {
    path: "/setting-plans",
    component: SettingPlans,
    exact: true,
  },
  {
    path: "/setting-payment",
    component: SettingPayment,
    exact: true,
  },
  {
    path: "/midtrans-configuration",
    component: MidtransConfiguration,
    exact: true,
  },
  {
    path: "/setting-cancellation",
    component: Cancellation,
    exact: true,
  },
  {
    path: "/add-plan",
    component: ModifyPLan,
    exact: true,
  },
  {
    path: "/edit-plan",
    component: ModifyPLan,
    exact: true,
  },
  {
    path: "/detail-plan",
    component: DetailPlan,
    exact: true,
  },
  {
    path: "/classes",
    component: Classes,
    exact: true,
  },
  {
    path: "/add-class",
    component: AddClass,
    exact: true,
  },
  {
    path: "/class/:id/detail",
    component: DetailClass,
    exact: true,
  },
  {
    path: "/class/:id/edit",
    component: EditClass,
    exact: true,
  },
  {
    path: "/teachers",
    component: Teachers,
    exact: true,
  },
  {
    path: "/add-teacher",
    component: AddTeachers,
    exact: true,
  },
  {
    path: "/teacher/:id/edit",
    component: AddTeachers,
    exact: true,
  },
  {
    path: "/teacher/:id/detail",
    component: TeacherDetail,
    exact: true,
  },
  {
    path: "/profile",
    component: EditProfile,
    exact: true,
  },
  {
    path: "/change-email",
    component: ChangeEmailOwner,
    exact: true,
  },
  {
    path: "/verify-email",
    component: VerifyEmailOwner,
    exact: true,
  },
];

const teacher_routes = [
  {
    path: "/dashboard",
    component: TeacherDashBoard,
    exact: true,
  },
  {
    path: "/dashboard-class-detail",
    component: DashboardClassDetail,
    exact: true,
  },
  {
    path: "/students",
    component: Students,
    exact: true,
  },
  {
    path: "/add-student",
    component: AddStudent,
    exact: true,
  },
  {
    path: "/student/:id/detail",
    component: DetailStudent,
    exact: true,
  },
  {
    path: "/student/:id/edit",
    component: AddStudent,
    exact: true,
  },
  {
    path: "/add-notes",
    component: AddNotes,
    exact: true,
  },
  {
    path: "/classes",
    component: Classes,
    exact: true,
  },
  {
    path: "/add-class",
    component: AddClass,
    exact: true,
  },
  {
    path: "/class/:id/detail",
    component: DetailClass,
    exact: true,
  },
  {
    path: "/class/:id/edit",
    component: EditClass,
    exact: true,
  },
  {
    path: "/profile",
    component: EditProfile,
    exact: true,
  },
  {
    path: "/change-email",
    component: ChangeEmailOwner,
    exact: true,
  },
  {
    path: "/verify-email",
    component: VerifyEmailOwner,
    exact: true,
  },
];

const student_routes = [
  {
    path: "/dashboard",
    component: StudentDashboard,
    exact: true,
  },
  {
    path: "/cancel-class",
    component: CancelClass,
    exact: true,
  },
  {
    path: "/cancel-class-complete",
    component: CancelClassComplete,
    exact: true,
  },
  {
    path: "/plan-list",
    component: PlanList,
    exact: true,
  },
  {
    path: "/plan-transaction/:id/detail",
    component: DetailTransaction,
    exact: true,
  },
  {
    path: "/buy-plan",
    component: BuyPlans,
    exact: true,
  },
  {
    path: "/online-payment-success",
    component: MidtransCallbackSucces,
    exact: true,
  },
  {
    path: "/class-list",
    component: ClassList,
    exact: true,
  },
  {
    path: "/payment-class/:id/detail",
    component: PaymentClass,
    exact: true,
  },
  {
    path: "/confirm-class",
    component: ConfirmClass,
    exact: true,
  },
  {
    path: "/choose-payment",
    component: ChoosePayment,
    exact: true,
  },
  {
    path: "/bank-transfer",
    component: BankTransfer,
    exact: true,
  },
  {
    path: "/waiting-payment",
    component: WaitingPayment,
    exact: true,
  },
  {
    path: "/payment-verification",
    component: PaymentVerification,
    exact: true,
  },
  {
    path: "/payment-processed",
    component: PaymentProcessed,
    exact: true,
  },
  {
    path: "/student-profile",
    component: StudentProfile,
    exact: true,
  },
  {
    path: "/change-email",
    component: ChangeEmail,
    exact: true,
  },
  {
    path: "/verify-email",
    component: VerifyEmail,
    exact: true,
  },
];

const WithAuthenRoute = ({ component: Component, user }) => {
  return (
    <Route
      exact
      render={(props) => {
        if (user.token) {
          return <Component {...props} />;
        }

        return <Redirect to="/login" />;
      }}
    />
  );
};

const StudioRoute = ({
  component: Component,
  cookies,
  loginFromStudio,
  isRegisterStudent,
}) => {
  const user_token =
    isRegisterStudent || loginFromStudio ? cookies?.token : cookies.user?.token;

  return (
    <Route
      exact
      render={(props) => {
        if (user_token) {
          return <Component {...props} />;
        }

        return <Redirect to="/studio-login" />;
      }}
    />
  );
};

const renderAuthenticatedRoute = (user) => {
  if (user?.role === "superadmin") {
    return admin_routes.map(({ path, component }) => (
      <WithAuthenRoute
        key={path}
        path={path}
        component={component}
        user={user}
      />
    ));
  } else {
    return routes.map(({ path, component }) => (
      <WithAuthenRoute
        key={path}
        path={path}
        component={component}
        user={user}
      />
    ));
  }
};

const renderStudioRoute = (cookies, loginFromStudio, isRegisterStudent) => {
  if (cookies?.role === "owner" || cookies.user?.role === "owner") {
    return studio_routes.map(({ path, component }) => (
      <StudioRoute
        key={path}
        path={path}
        component={component}
        cookies={cookies}
        loginFromStudio={loginFromStudio}
        isRegisterStudent={isRegisterStudent}
      />
    ));
  } else if (cookies?.role === "teacher" || cookies.user?.role === "teacher") {
    return teacher_routes.map(({ path, component }) => (
      <StudioRoute
        key={path}
        path={path}
        component={component}
        cookies={cookies}
        loginFromStudio={loginFromStudio}
        isRegisterStudent={isRegisterStudent}
      />
    ));
  } else if (cookies?.role === "student" || cookies.user?.role === "student") {
    return student_routes.map(({ path, component }) => (
      <StudioRoute
        key={path}
        path={path}
        component={component}
        cookies={cookies}
        loginFromStudio={loginFromStudio}
        isRegisterStudent={isRegisterStudent}
      />
    ));
  }

  return <Redirect to="/studio-login" />;
};

const Routes = () => {
  const [cookies, setCookie] = useCookies(["subdomain", "user"]);
  const { user, login_email, loginFromStudio } = useSelector(
    (state) => state.user
  );
  const { user_studio, isRegisterStudent } = useSelector(
    (state) => state.studio
  );

  const subdomain = window.location.host.split(".")[0];

  const dataUser = loginFromStudio
    ? user
    : isRegisterStudent
    ? user_studio
    : cookies;

  const redirect =
    loginFromStudio || isRegisterStudent ? "/studio-login" : "/login";

  return (
    <Router>
      <Switch>

        {subdomain === process.env.REACT_APP_HOST.split(".")[0] ? (
          <Route exact key="/login" path="/login" component={Login} />
        ) : (
          <Route
            exact
            key="/studio-login"
            path="/studio-login"
            component={StudioLogin}
          />
        )}

        {subdomain === process.env.REACT_APP_HOST.split(".")[0] ? (
          <Route exact key="/register" path="/register" component={Register} />
        ) : (
          <Route
            exact
            key="/register-student"
            path="/register-student"
            component={RegisterStudent}
          />
        )}

        <Route
          exact
          key="/general-terms"
          path="/general-terms"
          component={GeneralTerms}
        />

        <Route
          exact
          key="/public-class-list"
          path="/public-class-list"
          component={PublicClassList}
        />
        <Route
          exact
          key="/verify"
          path="/verify"
          component={VerifyOtp}
          // render={(props) => {
          //   if (login_email !== "") {
          //     return <VerifyOtp {...props} />;
          //   }

          //   return <Redirect to={redirect} />;
          // }}
        />
        {subdomain === process.env.REACT_APP_HOST.split(".")[0]
          ? renderAuthenticatedRoute(user)
          : renderStudioRoute(dataUser, loginFromStudio, isRegisterStudent)
        }

        <Route
          exact
          path="/"
          render={() =>
            subdomain === process.env.REACT_APP_HOST.split(".")[0] ? (
              <Redirect to={redirect} />
            ) : (
              <Redirect to="/dashboard" />
            )
          }
        />
      </Switch>
    </Router>
  );
};

export default Routes;
